export default [
  { value: 'AHCMO', display: 'AHCMO' },
  { value: 'ALBIR', display: 'ALBIR - Alabama Birmingham' },
  // { value: 'ALMOB', display: 'ALMOB - Alabama Mobile' },
  { value: 'AMITA', display: 'AMITA' },
  { value: 'DCWAS', display: 'DCWAS - Washington DC' },
  { value: 'FLJAC', display: 'FLJAC - Florida Jacksonville' },
  { value: 'FLPEN', display: 'FLPEN - Florida Pensacola' },
  { value: 'INEVA', display: 'INEVA - Indiana Evansville' },
  { value: 'ININD', display: 'ININD - Indiana Indianapolis' },
  { value: 'KSWIC', display: 'KSWIC - Kansas Wichita' },
  { value: 'MDBAL', display: 'MDBAL - Maryland Baltimore' },
  { value: 'MIDET', display: 'MIDET - Michigan Detroit' },
  { value: 'MIROC', display: 'MIROC - Michigan Rochester' },
  // { value: 'MISAG', display: 'MISAG - Michigan Saginaw' },
  { value: 'MIGRA', display: 'MIGRA - Michigan Grand Blanc' },
  { value: 'MIKAL', display: 'MIKAL - Michigan Kalamazoo' },
  // { value: 'MITAW', display: 'MITAW - Michigan Tawas' },
  { value: 'MOSTL', display: 'MOSTL - Missouri St. Louis' },
  // { value: 'NYAMS', display: 'NYAMS - New York Amsterdam' },
  // { value: 'NYBIN', display: 'NYBIN - New York Binghamton' },
  { value: 'OKTUL', display: 'OKTUL - Oklahoma Tulsa' },
  { value: 'TNNAS', display: 'TNNAS - Tennessee Nashville' },
  { value: 'TXAUS', display: 'TXAUS - Texas Austin' },
  { value: 'TXWAC', display: 'TXWAC - Texas Waco' },
  { value: 'WIAPP', display: 'WIAPP - Wisconsin Appleton' },
  { value: 'WIMIL', display: 'WIMIL - Wisconsin Milwaukee' },
  { value: 'CHMAR', display: 'Community Health Arkansas' },
  { value: 'CHMEP', display: 'Community Health El Paso' },
  { value: 'CHMNO', display: 'Community Health New Orleans' },
  { value: 'CHMKC', display: 'Community Health Kansas City' },
  { value: 'CHMSA', display: 'Community Health San Antonio' },
  { value: 'Ascension Living', display: 'Ascension Living' }
];
